import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useCloseDrawer = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    () =>
      dispatch({
        type: 'CLOSE',
      }),
    [dispatch],
  );
};
